import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TypewriterLink from './TypewriterLink';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    // Set manual navigation flag to prevent auto-scroll interference
    const heroSection = document.querySelector('[data-section="hero"]');
    if (heroSection) {
      // Dispatch a custom event to notify Hero component
      window.dispatchEvent(new CustomEvent('manualNavigation', { 
        detail: { targetId, timestamp: Date.now() } 
      }));
    }
    
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      // Account for fixed header height
      const headerHeight = 80; // Approximate header height
      const targetPosition = targetElement.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleLogoClick = () => {
    console.log('Logo clicked! Current location:', location.pathname);
    
    // If on home page, scroll to top
    if (location.pathname === '/') {
      console.log('On home page - scrolling to top...');
      
      // Scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // Set manual navigation flag to prevent auto-scroll interference
      const heroSection = document.querySelector('[data-section="hero"]');
      if (heroSection) {
        // Dispatch a custom event to notify Hero component
        window.dispatchEvent(new CustomEvent('manualNavigation', { 
          detail: { targetId: 'top', timestamp: Date.now() } 
        }));
      }
    } else {
      // If on other pages, navigate to home page
      console.log('On other page - navigating to home...');
      navigate('/');
    }
  };

  const handleMobileNavClick = (e, targetId) => {
    handleNavClick(e, targetId);
  };

  return (
    <header
      className="flex items-center justify-between px-4 md:px-8 py-4 mb-4 fixed top-0 left-0 right-0 w-full z-[1000] box-border bg-white shadow-lg border-b border-gray-200"
      style={{
        opacity: 1,
      }}
    >
      <div className="flex items-center">
        <div 
          className="cursor-pointer hover:opacity-80 transition-opacity duration-200 p-2 -m-2" 
          onClick={handleLogoClick}
          title="Click to go to top"
        >
          <img 
            src={process.env.PUBLIC_URL + '/images/logo/logo.webp'} 
            alt="73 Dotts Logo" 
            className="h-16 md:h-20 flex-shrink-0" 
          />
        </div>
      </div>
      
      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-8" style={{ fontFamily: "Raleway, sans-serif" }}>
        <div className="relative group">
          <a href="#about" onClick={(e) => handleNavClick(e, 'about')} className="text-black hover:text-accent transition-colors duration-200">
            <TypewriterLink text="About" href="#about" />
          </a>
          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-accent transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></div>
        </div>
        <div className="relative group">
          <a href="#services" onClick={(e) => handleNavClick(e, 'services')} className="text-black hover:text-accent transition-colors duration-200">
            <TypewriterLink text="Services" href="#services" />
          </a>
          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-accent transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></div>
        </div>
        <div className="relative group">
          <a href="#gallery" onClick={(e) => handleNavClick(e, 'gallery')} className="text-black hover:text-accent transition-colors duration-200">
            <TypewriterLink text="Gallery" href="#gallery" />
          </a>
          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-accent transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></div>
        </div>
        <div className="relative group">
          <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} className="text-black hover:text-accent transition-colors duration-200">
            <TypewriterLink text="Contact Us" href="#contact" />
          </a>
          <div className="absolute bottom-0 left-0 w-full h-0.5 bg-accent transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></div>
        </div>
      </nav>

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMenu}
        className="md:hidden flex flex-col space-y-1 p-2"
        aria-label="Toggle menu"
      >
        <span className={`block w-6 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
        <span className={`block w-6 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
        <span className={`block w-6 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
      </button>

      {/* Mobile Navigation Menu */}
      <div className={`md:hidden absolute top-full left-0 right-0 bg-white shadow-lg transition-all duration-300 ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        <nav className="flex flex-col py-4" style={{ fontFamily: "Raleway, sans-serif" }}>
          <a href="#about" className="px-6 py-3 text-black hover:bg-gray-100 transition-colors duration-200" onClick={(e) => handleMobileNavClick(e, 'about')}>About</a>
          <a href="#services" className="px-6 py-3 text-black hover:bg-gray-100 transition-colors duration-200" onClick={(e) => handleMobileNavClick(e, 'services')}>Services</a>
          <a href="#gallery" className="px-6 py-3 text-black hover:bg-gray-100 transition-colors duration-200" onClick={(e) => handleMobileNavClick(e, 'gallery')}>Gallery</a>
          <a href="#contact" className="px-6 py-3 text-black hover:bg-gray-100 transition-colors duration-200" onClick={(e) => handleMobileNavClick(e, 'contact')}>Contact Us</a>
        </nav>
      </div>
    </header>
  );
}

export default Header; 